import React from "react";
import Typography from "@mui/material/Typography";
import Container from "@mui/material/Container";
import Box from "@mui/material/Box";

import aces from "images/aces.avif";

function Info() {

  return (
    <Container 
      sx={{
        padding: "32px 24px",
        maxWidth: "800px",
        margin: "0 auto",
      }}
    >
      <Box sx={{ marginBottom: "32px" }}>
        <Typography 
          variant="h3" 
          component="h1" 
          sx={{
            marginBottom: "16px",
            color: "primary.main",
          }}
        >
          About Local Poker
        </Typography>
        <Typography 
          variant="h5" 
          component="h2" 
          sx={{
            marginBottom: "24px",
            color: "text.secondary",
          }}
        >
          By card players, for card players
        </Typography>
        <Typography 
          variant="body1" 
          sx={{
            marginBottom: "16px",
            lineHeight: 1.6,
          }}
        >
          We built this app to connect the friendly community of card players,
          looking for local games.
        </Typography>
      </Box>

      <Box
        component="img"
        src={aces}
        alt="Aces Photo"
        sx={{
          borderRadius: "20px",
          width: "100%",
          maxWidth: "600px",
          height: "auto",
          display: "block",
          margin: "24px auto",
        }}
      />

      <Box sx={{ marginBottom: "32px" }}>
        <Typography 
          variant="h4" 
          component="h2" 
          sx={{
            marginBottom: "16px",
            color: "primary.main",
          }}
        >
          Getting Started!
        </Typography>
        <Typography 
          variant="body1" 
          sx={{
            marginBottom: "16px",
            lineHeight: 1.6,
          }}
        >
          Getting set up is simple! Just register an account, and you will be
          able to see all the local games happening near you!
          <br />
          <br />
          Click the "Join Game" button for any game, and a request will be sent
          to the game owner for you to join! Once the Game Host has accepted
          your request, you will be able to see info of where to find the game,
          and you will be able to message the host directly through our secure
          messaging service. (It may be the host's decision to send out location
          info through private messages or perform other means of establishing
          trust before sending out this information)
        </Typography>
      </Box>

      <Box sx={{ marginBottom: "32px" }}>
        <Typography 
          variant="h4" 
          component="h2" 
          sx={{
            marginBottom: "16px",
            color: "primary.main",
          }}
        >
          Interested in Hosting?
        </Typography>
        <Typography 
          variant="body1" 
          sx={{
            marginBottom: "16px",
            lineHeight: 1.6,
          }}
        >
          Since we are currently in beta, we are requiring an access code to
          host games. Getting your own access code is simple, though! Just send
          us an email at LocalPokerContact@gmail.com, and we will get back to
          you ASAP with a code!
        </Typography>
      </Box>

      <Box sx={{ marginBottom: "32px" }}>
        <Typography 
          variant="h4" 
          component="h2" 
          sx={{
            marginBottom: "16px",
            color: "primary.main",
          }}
        >
          Who Are We?
        </Typography>
        <Typography 
          variant="body1" 
          sx={{
            marginBottom: "16px",
            lineHeight: 1.6,
          }}
        >
          We saw a need to connect card players and our team set out to create 
          Local Poker to fill that need.
        </Typography>
      </Box>
    </Container>
  );
}

export default Info;